'use client'

import { WebVitals } from '@thebeansgroup/js-open-telemetry/components/web_vitals'

import FeatureToggle from '@helpers/feature_toggle'

const WebVitalsWrapper = () => {
  return (
    <WebVitals
      clientMetricsEnabled={FeatureToggle.isEnabled('client_side_metrics')}
      endpointUrl={process.env.NEXT_PUBLIC_OTEL_CLIENT_METRICS_ENDPOINT}
      apiKey={process.env.NEXT_PUBLIC_OTEL_CLIENT_API_KEY}
      project={process.env.NEXT_PUBLIC_OTEL_NAME}
      environment={process.env.NEXT_PUBLIC_APP_ENV}
      metricSamplingPercentage={
        process.env.NEXT_PUBLIC_OTEL_METRIC_SAMPLING_RATE
      }
    />
  )
}

export default WebVitalsWrapper
